<script setup lang="ts">
import HeroSection from '~/components/home-sections/HeroSection.vue';
import LogoCarousel from '~/components/home-sections/LogoCarousel.vue';
import CaseStudiesSection from '~/components/home-sections/CaseStudiesSection.vue';
import FundraisingForSection from '~/components/home-sections/FundraisingForSection.vue';
import HowItWorksSection from '~/components/home-sections/HowItWorksSection.vue';
import FeaturesSection from '~/components/home-sections/FeaturesSection.vue';
import WhyRunARaffleboxSection from '~/components/home-sections/WhyRunARaffleboxSection.vue';
import TrustedBySection from '~/components/home-sections /TrustedBySection.vue';

definePageMeta({
  layout: 'default',
});

useSeoMeta({
  title: "Rafflebox - Manage Your Online Raffles & 50/50's",
  description:
    'Join thousands of community organizations - big and small - who raise more funds for their worthy causes with Rafflebox.',
});
</script>

<template>
  <div>
    <HeroSection />
    <LogoCarousel />
    <HowItWorksSection />
    <CaseStudiesSection />
    <FundraisingForSection />
    <FeaturesSection />
    <WhyRunARaffleboxSection />
    <TrustedBySection />
  </div>
</template>
